<template>
  <div v-if="typedNodes.length > 0">
    <a href="#" @click="() => expanded = !expanded">
      <i class="fa" :class="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </a>

    <input :indeterminate.prop="partial" @change="toggleAll" :checked="selected" type="checkbox" />
    <span>{{ nodeTypeLabel }} ({{ typedNodes.length }})</span>
    <div v-if="expanded">
      <div v-for="(node, i) in typedNodes" :key="'node-'+i" class="inset-2">
        <input v-model="node.selected" type="checkbox" />
        {{ node.title }}
      </div>
    </div>
    <a v-else href="#" @click="() => expanded = true">
      <div class="inset-1">•••</div>
    </a>
  </div>
</template>

<script>
export default {
  name: "node-type-dropdown",
  components: {},
  props: ["location", "type"],
  data: () => ({
    expanded: true,
  }),
  methods: {
    toggleAll() {
      if (this.typedNodes.every(node => node.selected)) {
        this.typedNodes.forEach(node => (node.selected = false));
      } else {
        this.typedNodes.forEach(node => (node.selected = true));
      }
    }
  },
  computed: {
    nodeTypeInt() {
      return this.$consts.NODE_TYPE_STR_TO_INT[this.type];
    },
    nodeTypeLabel() {
      return this.$consts.NODE_LABELS_FOR_PATH_TYPE[this.type];
    },
    typedNodes() {
      return this.location.nodes[this.nodeTypeInt];
    },
    ratioSelected() {
      let numSelected = 0;
      let numSeen = 0;
      for (let i = 0; i < this.typedNodes.length; i++) {
        let node = this.typedNodes[i];
        if (node.selected) numSelected++;
        numSeen++;
      }
      return { selected: numSelected, total: numSeen };
    },
    partial() {
      let ratio = this.ratioSelected;
      return ratio.selected > 0 && ratio.selected < ratio.total;
    },
    selected() {
      let ratio = this.ratioSelected;
      return ratio.selected === ratio.total;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>